import { jsx } from 'react/jsx-runtime';
import React__default, { useMemo } from 'react';
import { useMutationResourcesTagAssign } from '../mutations/useMutationResourcesTagAssign.js';
import { useQueryMultipleResourceTags } from '../queries/useQueryResourceTags.js';
import { getSelectedAndSemiselectedTagIds } from '../utils.js';
import { MagicSuggestionsContextProvider } from '../../magic/components/MagicSuggestionsContext.js';
import EditTagsModal from './EditTagsModal.js';

const EditTagsPerMultipleResourcesModal = ({ resourceIds, modalControls }) => {
  const mutationResourcesTagAssign = useMutationResourcesTagAssign();
  const { data: queryResourcesTagsData } = useQueryMultipleResourceTags(resourceIds, {
    enabled: modalControls.open
  });
  const { selectedTags, indeterminateTags } = React__default.useMemo(() => getSelectedAndSemiselectedTagIds(queryResourcesTagsData), [
    queryResourcesTagsData
  ]);
  const selectHandler = (tag, selected) => {
    mutationResourcesTagAssign.mutate({
      tag,
      resourceIds,
      operation: selected ? "assign" : "unassign"
    });
  };
  const suggestionsContext = useMemo(() => modalControls.open ? {
    resourceIds
  } : void 0, [
    modalControls.open,
    resourceIds
  ]);
  return /* @__PURE__ */ jsx(MagicSuggestionsContextProvider, {
    context: suggestionsContext,
    keepPrevious: false,
    includeFolders: false,
    children: /* @__PURE__ */ jsx(EditTagsModal, {
      ...modalControls,
      selectedTags,
      indeterminateTags,
      onSelect: selectHandler,
      selectedResourcesCount: resourceIds.length
    })
  });
};

export { EditTagsPerMultipleResourcesModal };
//# sourceMappingURL=EditTagsPerMultipleResourcesModal.js.map
